import { useEffect, useState, type ReactNode } from 'react';
import { authApi } from '../../api/auth';
import { useAuthStore } from '../../store/authStore';
import './SessionBootstrap.css';

// Reconcile identity on document load, including returns from legacy tools.
export function SessionBootstrap({ children }: { children: ReactNode }) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    let active = true;
    authApi.resumeSession().then(response => {
      if (!active) return;
      const session = response.data?.data;
      if (response.data?.success && session?.user && session?.token) useAuthStore.getState().setAuth(session.user, session.token);
    }).catch(error => {
      if (active && error.response?.status === 401) useAuthStore.getState().logout();
    }).finally(() => { if (active) setChecked(true); });
    return () => { active = false; };
  }, []);
  return checked ? <>{children}</> : (
    <div
      className="session-loading"
      role="status"
      aria-label="Opening your awareness workspace"
      aria-live="polite"
    >
      <span className="session-loading-spinner" aria-hidden="true" />
      <span>Opening your awareness workspace…</span>
    </div>
  );
}
